import { useState } from "react";
import { useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import { Button } from "..";
import { AlertMessage } from "../AlertMessage";
import { useRef } from "react";
import { Box, Typography } from "@mui/material";
import { resetPasswordApi } from "../../utils/IdentityService/EmailVerificationApi";
import recoveryLink from "../../assets/images/recovery-link.png";

const ButtonContainer = styled('div')(({ theme: { breakpoints } }) => `
  display: flex;
  justify-content: space-evenly;
  width: 40%;
  margin: 50px auto 40% auto;
  ${[breakpoints.down('sm')]} {
    width: 60%;
    margin-top: 130px;
    margin-bottom: 150px;
  }
`);

const recoveryLinkContent = {
  headline: 'Recovery Link sent!',
  message: 'We’ve sent you an email with the information needed to reset your password. The email might take a couple of minutes to reach your account.',
  icon: recoveryLink
}

export const RecoveryLink = () => {
  const [processing, setProcessing] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const alertRef = useRef(null)
  const { globalErrorMessage } = useSelector(store=>store?.globalMessages);
  const generalApiErrorData = globalErrorMessage && globalErrorMessage.length && globalErrorMessage.filter((data) => data?.fields?.code === "GENERAL_API_ERROR");
  const generalApiError = generalApiErrorData && generalApiErrorData[0]?.fields?.message;
  const emailAddress = useSelector(state => state.globalStates.emailAddress);

  const handleRecoveryLink = async (e) => {
    e.preventDefault();
    setProcessing(true);
    if (localStorage.getItem("recoverPassEmail")) {
      try {
        const res = await resetPasswordApi({emailAddress: emailAddress});
        if (res?.status === 200) {
          setProcessing(false);
        }
      } catch (err) {
        setErrorMsg(generalApiError);
        setProcessing(false);
        alertRef.current?.openAlert();
      }
    }
  }

  const handleResendLink = handleRecoveryLink

  return (
    <div>
      <AlertMessage variant={"filled"} type={"error"} message={errorMsg} ref={alertRef}/>
      <Box component={'img'} margin={{xs:'50px auto 20px auto',sm:'20px auto'}} display='flex' id="recoveryLinkImg" src={recoveryLinkContent.icon} width="90px" height="90px"></Box>
      <Typography variant={'h1'} textAlign='center' color='primary.main' id="headline" data-testid='title'>{recoveryLinkContent.headline}</Typography>
      <Typography variant={'p1'} textAlign='center' pt={'8px'} sx={{userSelect: 'text'}} display={'flex'} justifyContent={'center'} id="emailSentMessage" data-testid='message'>{recoveryLinkContent.message}</Typography>
      <ButtonContainer>
        <Button
          id="resendLinkButton"
          buttonType="secondary"
          onClick={handleResendLink}
          loading={processing}
          data-testid='resendBtn'
        >RESEND LINK
        </Button>
      </ButtonContainer>
    </div>
  )
};